module.exports = __webpack_public_path__ + "img/cross_2.11ce5ef8.svg";